/**
 * Wrapper for File with additional information about relative path.
 * Used for files from drag&drop directories.
 */
export interface FileWithPath {
  readonly file: File;
  readonly relativePath: string;
}

export function createFileWithPath(
  file: File,
  relativePath: string
): FileWithPath {
  return {
    file,
    relativePath,
  };
}

/**
 * Converts FileWithPath to File with webkitRelativePath property.
 * Creates a new File object, because webkitRelativePath is read-only.
 *
 * @param fileWithPath - FileWithPath to convert
 * @returns File with webkitRelativePath property
 */
export function fileWithPathToFile(fileWithPath: FileWithPath): File {
  const { file, relativePath } = fileWithPath;

  const newFile = new File([file], file.name, {
    type: file.type,
    lastModified: file.lastModified,
  });

  Object.defineProperty(newFile, 'webkitRelativePath', {
    value: relativePath,
    writable: false,
    enumerable: true,
    configurable: false,
  });

  return newFile;
}

export function convertToFilesArray(
  filesWithPath: FileWithPath[]
): File[] {
  return filesWithPath.map(fileWithPathToFile);
}
